import { useFedStore, useL } from '../store';
import { LIVE_DEFAULTS } from '../data';
import { useFedContent } from '../content';
import { Ic } from '../icons';
import { Rv, Eyebrow } from '../ui';

const TWITCH_URL = 'https://www.twitch.tv/cybersqo';

const COPY = {
  ru: {
    title: 'Эфиры федерации',
    subtitle: 'Смотрите прямые трансляции турниров, матчей и событий Федерации киберспорта Северо-Казахстанской области.',
    channel: 'Официальный канал федерации',
    offline: 'Сейчас эфир не идёт',
    hint: 'Когда начнётся следующая трансляция, мы сообщим об этом на сайте и в социальных сетях.',
    open: 'Открыть Twitch',
    window: 'Перейти на канал',
    status: 'Ближайший эфир',
    noDate: 'Дата пока не объявлена',
    noDateText: 'Расписание появится здесь после анонса следующего турнира.',
    follow: 'Подпишитесь на канал, чтобы Twitch заранее уведомил вас о начале трансляции.',
    archive: 'Записи трансляций',
    archiveText: 'Записи прошедших матчей и турниров публикуются на YouTube-канале федерации.',
    youtube: 'Открыть YouTube',
  },
  kz: {
    title: 'Федерация эфирлері',
    subtitle: 'Солтүстік Қазақстан облысының киберспорт федерациясы турнирлерінің, матчтары мен іс-шараларының тікелей көрсетілімдерін көріңіз.',
    channel: 'Федерацияның ресми арнасы',
    offline: 'Қазір эфир жоқ',
    hint: 'Келесі трансляция басталғанда, бұл туралы сайтта және әлеуметтік желілерде хабарлаймыз.',
    open: 'Twitch-ті ашу',
    window: 'Арнаға өту',
    status: 'Келесі эфир',
    noDate: 'Күні әлі жарияланған жоқ',
    noDateText: 'Кесте келесі турнир жарияланғаннан кейін осында шығады.',
    follow: 'Трансляцияның басталғаны туралы алдын ала хабарлама алу үшін арнаға жазылыңыз.',
    archive: 'Трансляция жазбалары',
    archiveText: 'Өткен матчтар мен турнирлердің жазбалары федерацияның YouTube арнасында жарияланады.',
    youtube: 'YouTube-ты ашу',
  },
};

const RED = {
  bright: '#ff3037',
  accent: '#e11217',
  deep: '#72080c',
  line: 'rgba(255,64,70,.38)',
  glow: 'rgba(225,18,23,.46)',
  soft: 'rgba(225,18,23,.12)',
};

export default function FedLive() {
  const lang = useFedStore((state) => state.lang);
  const L = useL();
  const live = useFedContent((state) => state.live) || LIVE_DEFAULTS;
  const youtubeUrl = live.youtube || LIVE_DEFAULTS.youtube;
  const T = COPY[lang === 'kz' ? 'kz' : 'ru'];

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 80px' }}>
      <Rv style={{ marginBottom: 28 }}>
        <Eyebrow className="flex items-center gap-2" style={{ marginBottom: 12 }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--fed-fg-faint)' }} />
          {L.nav_live}
        </Eyebrow>
        <h1 style={{ fontSize: 'clamp(38px,6vw,68px)' }}>{T.title}</h1>
        <p className="max-w-[720px] text-fg-soft" style={{ marginTop: 14, fontSize: 16, lineHeight: 1.65 }}>{T.subtitle}</p>
      </Rv>

      <div className="fed-split-2" style={{ gridTemplateColumns: '1.55fr .85fr' }}>
        <Rv className="flex flex-col gap-4">
          <div className="flex items-center gap-2.5 flex-wrap">
            <span className="inline-flex items-center gap-2 rounded-full font-mono uppercase text-white" style={{ padding: '7px 12px', fontSize: 10.5, letterSpacing: '.1em', background: `linear-gradient(120deg,${RED.bright},${RED.deep})`, boxShadow: `0 9px 22px -12px ${RED.glow}` }}>
              <Ic name="twitch" size={14} /> Twitch
            </span>
            <span className="font-display font-bold text-fg" style={{ fontSize: 16 }}>{T.channel}</span>
            <span className="font-mono text-fg-faint" style={{ fontSize: 11 }}>twitch.tv/cybersqo</span>
          </div>

          <div className="relative overflow-hidden rounded-[20px] border" style={{ aspectRatio: '16/9', borderColor: RED.line, background: '#000' }}>
            <iframe
              title="Twitch — cybersqo"
              src={`https://player.twitch.tv/?channel=cybersqo&parent=${encodeURIComponent(window.location.hostname)}&autoplay=false`}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 h-full w-full border-0"
            />
          </div>

          <div className="rounded-2xl bg-surface border border-line" style={{ padding: 20 }}>
            <p className="text-fg-muted" style={{ fontSize: 13.5, lineHeight: 1.65, marginBottom: 15 }}>{T.follow}</p>
            <a href={TWITCH_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 h-11 px-5 rounded-[11px] no-underline font-display font-bold uppercase text-white" style={{ fontSize: 13, background: `linear-gradient(120deg,${RED.bright},${RED.deep})`, boxShadow: `0 12px 28px -14px ${RED.glow}` }}>
              <Ic name="twitch" size={17} /> {T.open}<Ic name="external" size={14} />
            </a>
          </div>
        </Rv>

        <Rv delay={0.08} className="flex flex-col gap-4">
          <div className="rounded-2xl" style={{ padding: 22, background: `linear-gradient(140deg,${RED.soft},var(--fed-surface) 58%)`, border: `1px solid ${RED.line}` }}>
            <div className="flex items-center gap-2 font-display font-bold text-fg" style={{ fontSize: 19 }}><Ic name="youtube" size={20} />{T.archive}</div>
            <p className="text-fg-muted" style={{ fontSize: 13, lineHeight: 1.6, marginTop: 9, marginBottom: 16 }}>{T.archiveText}</p>
            <a href={youtubeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex h-[42px] items-center px-[18px] rounded-[10px] bg-surface-2 border border-line-2 font-display font-semibold uppercase gap-2 no-underline" style={{ fontSize: 13, color: 'var(--fed-fg)' }}>
              <Ic name="youtube" size={18} /> {T.youtube}
            </a>
          </div>
        </Rv>
      </div>
    </div>
  );
}
